import * as React from 'react';
import { Tooltip } from 'reactstrap';

export interface ToolTipProps {
    children?: React.ReactElement,
    toolTipContent: string | React.ReactElement,
    target: string,
}

const ToolTip : React.FC<ToolTipProps> = (props) => {
    const {
        children,
        toolTipContent,
        target,
    } = props;

    const [tooltipOpen, setTooltipOpen] = React.useState(false);

    return (
        <>
            { children }
            <Tooltip 
                placement="bottom" 
                isOpen={tooltipOpen} 
                target={target} toggle={() => setTooltipOpen(!tooltipOpen)}
            >
                { toolTipContent }
            </Tooltip>
        </>
    );
}

export default ToolTip;